import { render, staticRenderFns } from "./msg401.vue?vue&type=template&id=66051cae&"
import script from "./msg401.vue?vue&type=script&lang=js&"
export * from "./msg401.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports